import CommonFunctions from "@orphy/scripts/CommonFunctions";
import ButtonFunctions from "@orphy/scripts/ButtonFunctions";
import "./Index.scss"

export class FormIndexBase {

    plz: string;
    city: string;
    billAttentionOfPlz: string;
    billAttentionOfCity: string;
    courseDetailAction: string;

    constructor(plz: string, city: string, billAttentionOfPlz: string, billAttentionOfCity: string, courseDetailAction: string, discountCodeValidateAction: string, courseId?: number) {
        this.plz = plz;
        this.city = city;
        this.billAttentionOfPlz = billAttentionOfPlz;
        this.billAttentionOfCity = billAttentionOfCity;
        this.courseDetailAction = courseDetailAction;

        $(document).ready(() => {
            // Resize iframe
            this.postFrameHeight();
            $(window).resize(() => this.postFrameHeight());
            window.parent.postMessage(['setScr', 0], '*');

            $("#SubmitModel_CouponCode").on("blur", (e) => {
                const code = (e.target as any).value;
                const selectedCourseId = CommonFunctions.isNullOrWhitespace($("#SubmitModel_SelectedCourseId").val() as string) ? null : parseInt($("#SubmitModel_SelectedCourseId").val() as string);
                if (CommonFunctions.isNullOrWhitespace(code)) {
                    $(e.target).closest(".controlGroupStandalone").find("#couponResult").html("");
                } else {
                    CommonFunctions.post(discountCodeValidateAction, { code, selectedCourseId },
                        (result) => {
                            if (result && result.valid) {
                                $(e.target).closest(".controlGroupStandalone").find("#couponResult").html(`<i class='icon-tick icons' style='font-size: 56px; color:green'><span style='vertical-align:12px;font-size:12px;'>${result.text}</span></i>`);
                            } else {
                                $(e.target).closest(".controlGroupStandalone").find("#couponResult").html(`<i class='icon-cross icons' style='font-size: 56px; color:red'><span style='vertical-align:12px;font-size:12px;'>${result.text}</span></i>`);
                            }
                        }, () => {
                            alert('error');
                        });
                }

            });

            if (courseId) {
                this.loadCourseData(courseId);
            }
        });
    }

    formSubmit = (e) => {
        const billAttentionOfCompanyNameInvalid = CommonFunctions.isNullOrWhitespace($("#SubmitModel_BillAttentionOfCompanyName").val() as string);
        const billAttentionOfFirstNameInvalid = CommonFunctions.isNullOrWhitespace($("#SubmitModel_BillAttentionOfFirstName").val() as string);
        const billAttentionOfLastNameInvalid = CommonFunctions.isNullOrWhitespace($("#SubmitModel_BillAttentionOfLastName").val() as string);
        
        const useAttentionOf = $('#PersonDataSignUpUseAttentionOfBillAddress').prop("checked");

        if (useAttentionOf) {
            if (billAttentionOfCompanyNameInvalid && (billAttentionOfFirstNameInvalid || billAttentionOfLastNameInvalid)) {
                $('#SubmitModel_BillAttentionOfCompanyName').attr("validationmessage", TextResources.CM_CompanyOrNameNeededForAttentionOf);
                $('#SubmitModel_BillAttentionOfCompanyName').attr("required", "required");
                $('#SubmitModel_BillAttentionOfFirstName').attr("validationmessage", TextResources.CM_CompanyOrNameNeededForAttentionOf);
                $('#SubmitModel_BillAttentionOfFirstName').attr("required", "required");
                $('#SubmitModel_BillAttentionOfLastName').attr("validationmessage", TextResources.CM_CompanyOrNameNeededForAttentionOf);
                $('#SubmitModel_BillAttentionOfLastName').attr("required", "required");
                return;
            }
        }
        // Mark the captcha as a required field up front so the Kendo validator picks it up,
        // then always run validation. Previously validate() only ran once the captcha was
        // already solved, so leaving any field (or the captcha) empty silently did nothing.
        $('#g-recaptcha-response').attr("validationmessage", TextResources.Views_Pflichtfeld);
        $('#g-recaptcha-response').attr("required", "required");
        ButtonFunctions.submit(e);
    }

    clearRequiredAttribute = () => {
        $('span[id^="SubmitModel.BillAttentionOfFirstName_validationMessage"]').remove()
        $('#SubmitModel_BillAttentionOfFirstName').closest('div .required').removeClass('invalid')
        $('#SubmitModel_BillAttentionOfFirstName').removeAttr("required");
        $('span[id^="SubmitModel.BillAttentionOfLastName_validationMessage"]').remove()
        $('#SubmitModel_BillAttentionOfLastName').closest('div .required').removeClass('invalid')
        $('#SubmitModel_BillAttentionOfLastName').removeAttr("required");
        $('span[id^="SubmitModel.BillAttentionOfCompanyName_validationMessage"]').remove()
        $('#SubmitModel_BillAttentionOfCompanyName').closest('div .required').removeClass('invalid')
        $('#SubmitModel_BillAttentionOfCompanyName').removeAttr("required");
    }

    postFrameHeight = () => {
        const height = document.getElementsByTagName('html')[0].scrollHeight
        window.parent.postMessage(['setHgt', height], '*');
    }

    courseSelected = (e) => {
        this.loadCourseData(e.dataItem.Value);
    };

    loadCourseData = (id) => {
        if (id) {
            CommonFunctions.getWithData(this.courseDetailAction, { courseId: id }, (result) => {
                $(".courseDetails").html(result);
                this.postFrameHeight();
            })
        } else {
            $(".courseDetails").html('');
            this.postFrameHeight();
        }
    }

    plzSelected = (e) => {
        this.City.value(e.dataItem.Ort);
    }

    citySelected = (e) => {
        this.Plz.value(e.dataItem.Plz);
    }

    billAttentionOfPlzSelected = (e) => {
        this.BillAttentionOfCity.value(e.dataItem.Ort);
    }

    billAttentionOfCitySelected = (e) => {
        this.BillAttentionOfPlz.value(e.dataItem.Plz);
    }

    get Plz(): kendo.ui.MultiSelect {
        return $(this.plz).data().kendoAutoComplete;
    }

    get BillAttentionOfPlz(): kendo.ui.MultiSelect {
        return $(this.billAttentionOfPlz).data().kendoAutoComplete;
    }

    get City(): kendo.ui.MultiSelect {
        return $(this.city).data().kendoAutoComplete;
    }
    get BillAttentionOfCity(): kendo.ui.MultiSelect {
        return $(this.billAttentionOfCity).data().kendoAutoComplete;
    }
}
